import React from 'react';
import { Button, Icon, Page, SentactFeedbackStamp} from "Components";
import CustomerLogo from "Images/CustomerLogo.jsx";
import IconTypeEnum from "Enum/IconTypeEnum";
import { goToPCareMenu } from "KeyboardEventHelper";
import {useSearchParams} from "react-router-dom";
import {handleProxyCustomErrorCode} from "UIDataHandler";

const ErrorPage = ({
    text=`Something went wrong. Check your survey link and try again.`,
    isKiosk,
    controllerMode,
}) => {
    const [searchParams] = useSearchParams();

    React.useEffect(() => {
        if (isKiosk) {
            setTimeout(() => {
                window.location.reload(true);
            }, 60000);
        }

        if (controllerMode) {
            setTimeout(() => {
                goToPCareMenu();
            }, 3000);
        }

        if (searchParams && searchParams.get('code')) {
            console.error('Error code : ' + searchParams.get('code') + '\n');
        }
    }, [])


    return <Page className={`flex flex-col h-full items-center text-center justify-around color1-text`}>
        <div className={`p-3 logo-container`}>{<CustomerLogo />}</div>
        <div className={`flex flex-col gap-16 text-center`}>
            <h1 className={`text-3xl md:text-4xl w-full m-auto`}>Error</h1>
                <div className={`flex-none text-xl w-fit mx-auto py-1 px-3 rounded-sm error-message font-light`}>{text}</div>
                <div className={`flex-none text-wrap mx-auto font-light text-sm`}>
                    <hr className={`w-6 mx-auto pb-3`} />
                    {isKiosk
                        ? <Button onClick={() => window.location.reload()} type={'large'} className={`m-auto`}>Home</Button>
                        : <div className={`w-10/12 md:w-7/12 mx-auto error-message-alt`}>
                            If you believe this is incorrect, please reach out to your Sentact admin for resolution.
                        </div>
                    }
                </div>
            <div className={`flex-none text-wrap mx-auto font-light text-sm`}>
                { controllerMode && <h2 className={`items-center md:flex md:flex-row md:gap-[10px]`} onClick={() => goToPCareMenu()}>Press <Icon type={IconTypeEnum.MENU} size={25} /> to Quit</h2>}
            </div>
        </div>
        <SentactFeedbackStamp />
    </Page>
};

export default ErrorPage;
